import * as React from "react"
import type { SVGProps } from "react"
const SvgRss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.43q-.82 0-1.41-.59A2 2 0 0 1 3 19.43q0-.82.59-1.41A2 2 0 0 1 5 17.43q.82 0 1.41.59.6.59.59 1.41c-.01.82-.2 1.02-.59 1.41a2 2 0 0 1-1.41.59m13.5 0q-.65 0-1.09-.48a2 2 0 0 1-.51-1.12 14 14 0 0 0-1.31-4.54 14 14 0 0 0-2.69-3.76 14 14 0 0 0-3.76-2.69A14 14 0 0 0 4.6 7.53a2 2 0 0 1-1.12-.51A1.4 1.4 0 0 1 3 5.93q0-.65.45-1.06t1.08-.37q3.08.28 5.76 1.57 2.69 1.28 4.74 3.34a17 17 0 0 1 3.33 4.73 17 17 0 0 1 1.57 5.77q.04.62-.37 1.07t-1.06.45m-6 0q-.62 0-1.07-.44a2 2 0 0 1-.58-1.06 8 8 0 0 0-.79-2.26 8 8 0 0 0-1.41-1.89 8 8 0 0 0-1.89-1.41 8 8 0 0 0-2.26-.79 2 2 0 0 1-1.06-.57A1.5 1.5 0 0 1 3 11.93q0-.65.45-1.08.45-.42 1.08-.32 1.82.25 3.4 1.06a11.2 11.2 0 0 1 4.9 4.9 11 11 0 0 1 1.07 3.41 1.2 1.2 0 0 1-.32 1.08q-.44.45-1.08.45" />
  </svg>
)
export default SvgRss
